import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import HistoryTableComp from "./Component/HistoryTableComp"


const TeacherHistoryTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <HistoryTableComp />
            
        </div>
        <Footer />
        </>
    )
}

export default TeacherHistoryTable